import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { purge } from '@vy/utils';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { useActivatedIntegration } from '../../../use-activated-integration';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { PaddleGetCustomersResponse } from '@vy/api-definition';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function usePaddleCustomers(
  searchParam?: string,
  options?: CustomUseQueryOptions<PaddleGetCustomersResponse>,
) {
  const isPaddleActivated = useActivatedIntegration(INTEGRATION_PROVIDERS.paddle);

  const queryDeps = purge([searchParam]);

  return useQuery(
    queryKeys.paddleCustomers(...queryDeps),
    async () => {
      const api = getPrivateApi();
      const response = await api.paddleGetCustomers({ search: searchParam });

      return response;
    },
    {
      ...options,
      enabled: isPaddleActivated,
    },
  );
}
